import { catalog, plural } from '@nolens/i18n';

export const savingsText = catalog(
  {
    spaceNotFound: 'Space not found.',
    ownerOnly: "Only the space's owner sees the team’s savings.",
    title: 'Estimated savings',
    summary: (steps: number, guides: number) =>
      `saved documenting ${steps} ${plural('en', steps, { one: 'step', other: 'steps' })} in ${guides} ${plural('en', guides, { one: 'guide', other: 'guides' })}`,
    notAMeasurement: 'It is not a measurement.',
    viewBy: 'View by',
    month: 'Month',
    person: 'Person',
    formerMember: 'Former member',
  },
  {
    'pt-PT': {
      spaceNotFound: 'Espaço não encontrado.',
      ownerOnly: 'Só o dono do espaço vê a poupança da equipa.',
      title: 'Poupança estimada',
      summary: (steps, guides) =>
        `poupados a documentar ${steps} ${plural('pt-PT', steps, { one: 'passo', other: 'passos' })} em ${guides} ${plural('pt-PT', guides, { one: 'guia', other: 'guias' })}`,
      notAMeasurement: 'Não é uma medição.',
      viewBy: 'Ver por',
      month: 'Mês',
      person: 'Pessoa',
      formerMember: 'Antigo membro',
    },
  },
);
